import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cached: string | null = null
let pending: Promise<string> | null = null

export async function getFingerprintId(timeoutMs = 1500): Promise<string> {
    if (cached) return cached
    if (pending) return pending

    pending = (async () => {
        try {
            const ctrl = new AbortController()
            const timer = setTimeout(() => ctrl.abort(), timeoutMs)
            const fp = await FingerprintJS.load()
            const {visitorId} = await fp.get()
            clearTimeout(timer)
            cached = visitorId
            return cached
        } catch {
            return 'fp-error'
        } finally {
            pending = null
        }
    })()

    return pending
}
